(function() {
  $('#Hero,#Hero_mobile').on('init', function(ev, el){
    $('video').each(function () {
      this.play();
    });
  });
})();
$(window).load(function(){
  $(".mainoverlay").hide();
});

// if(window.parent!=window){
//   $(".mainoverlay").hide();
// }

$('a.site-nav__link.cart-link.js-drawer-open-right').on('mousedown', function(){
    setTimeout(function(){
      $('header .wrapper .grid__item').css('margin-right', '0px');
      $('body').addClass('stuck');
      $('#cart_overlay').css('display', 'block');
    }, 300);
});

$(document).ready(function(){

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $mobileHero = $('#Hero_mobile');

  // The base theme initializes only #Hero. Initialize the mobile carousel on
  // DOM ready so its first paint is not held until every third-party asset has
  // fired window.load.
  if ($mobileHero.length && !$mobileHero.hasClass('slick-initialized')) {
    $mobileHero.slick({
      adaptiveHeight: true,
      dots: false,
      arrows: false,
      autoplay: false && !prefersReducedMotion,
      autoplaySpeed: 6000,
      fade: true
    });
  }

  setTimeout(function(){
    $('body').find("#rap__med__instabox").attr("style","width:100% !important");
    var calculated_height = $(".bottom-section .block-right-image").innerHeight();
    $(".block-insta").height(calculated_height);
  },1000);

  
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkCookie() {
    var user = getCookie("username");
    if (user != "") {
      alert("Welcome again " + user);
    } else {
      user = prompt("Please enter your name:", "");
      if (user != "" && user != null) {
        setCookie("username", user, 365);
      }
    }
  }

  //   jQuery("#mce-success-response").on("DOMSubtreeModified", function() {
  //     console.log("Success Message! :D");
  //     jQuery(".footerA.submitBT").text("Thank You");
  //   });

  jQuery(".site-nav__link.cartLink").on('click', function(e) {
    //return false;
    
    alert('here');
  });

  jQuery(".ajaxcart__product").last().addClass("last-cartitem");

  check_if_mobile();

  //   logged_in = false;

  //   if(logged_in){
  //     console.log("Person is Logged in");
  //     jQuery("a[href='/account/login']").text('ACCOUNT').attr('href','/account/');
  //   }
  //   else {
  //     console.log("Person is logged out.");
  //   }

  //   jQuery("ul.site-footer__linklist li").eq(3).find("a").attr('href','');

  if(navigator.userAgent.indexOf('Android') > 0 || navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Windows Phone') > 0 || navigator.userAgent.indexOf('iPad') > 0){
    jQuery(".grid-product__wrapper").on('click', function(e) {
      e.stopPropagation();
      // top.window.location.href=jQuery(this).find(".grid-product-information a").attr('href');
    });
  }

  setInterval(function(){  $(".js-qty input").attr("type","number");  }, 1000);  

  $('#Hero,#Hero_mobile').on('init', function(ev, el){
    $('video').each(function () {
      this.play();
    });
  });

  jQuery(".quick-view-items .share p").on('click', function() {
    jQuery(this).toggleClass('activated');
    jQuery(this).parent().siblings('.see-more').toggleClass('less_bottom_margin')
  });

  jQuery(".cont_list_container").on('click','li', function() {
    if(!jQuery(this).hasClass('active')) {
      jQuery(this).addClass('active').siblings().removeClass('active');
    }
  });

  jQuery(".hot_links").on('click', '.hot_links--item', function() {
    jQuery('.desktopviewonly').show();
    jQuery(".product-single__description").hide();
    if(!jQuery(this).hasClass('active'))  {
      jQuery(this).siblings().removeClass('active');
      jQuery(this).addClass('active');
      var title = jQuery(this).attr('data-title');
      jQuery(".selected_content p, .selected_content .container div ").hide();
      jQuery(".selected_content p."+title).show();
      jQuery(".selected_content p."+title).find("p").show();
      // jQuery(".mobilenew").hide();
    }
    else {
      if(jQuery(window).width() < 768) {
        jQuery(this).removeClass('active');
        var title = jQuery(this).attr('data-title');
        jQuery(".mobileContent."+title).hide();
      }
    }
  });

  
  var searchToggle = document.getElementById('search_toggle');
  var searchInput = document.getElementById('q');

  if (searchToggle && searchInput) {
    searchToggle.addEventListener('click', function(event) {
      event.preventDefault();
      var expanded = searchInput.classList.toggle('activated');
      searchToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (expanded) {
        searchInput.removeAttribute('tabindex');
        searchInput.focus();
      } else {
        searchInput.value = '';
        searchInput.setAttribute('tabindex', '-1');
      }
    });
  }

  if (Modernizr.touch){
    $(".quick-view-items").css("display", "none");
  }

  $(document).on("click", ".ajax_btn", function(){

    var remove_ajax_cart = $(this).siblings(".ajax_subBox").find(".ajaxcart__qty-num");
    $(remove_ajax_cart).attr("value", "0");
    $(remove_ajax_cart).trigger("change");

  });

  $(".quick_add").on("click", function(){
    //     alert("cart");
    //alert();
    if($(this).closest(".product-single__form").find(".size_list li").length == 0){
      $(this).closest(".product-single__form").find(".errorMsg").hide();
      return true;
    }


    var count = 0;
    $(this).closest(".product-single__add-to-cart").siblings(".size_list").find("li").each(function(){
      //       console.log($(this));

      if($(this).hasClass("selected"))
      {
        count++;
      }
      else
      {
      }
    });
    if(count == 0)
    {
      $(this).closest(".product-single__form").find(".errorMsg").show();
      return false;
    }
    else
    {
      $(this).closest(".product-single__form").find(".errorMsg").hide();
      //     	return false;
    }

    $(this).closest(".product-single__add-to-cart").siblings(".size_list").find("li").each(function(){
      $(this).removeClass("selected");
    });



  });



  //   $(".mobile-nav li").each(function(){
  //     var txt = $(this).find("a").text();
  //     if( txt.indexOf("About") > -1)
  //     { 
  //       	$("<ul class='footer_sub _hide'><li class='fb_li link_li' ><a title='Facebook' href='https://www.facebook.com/maimoun_ny/' target='_blank'><i class='fa fa-facebook' aria-hidden='true'></i></a></li><li class='insta_li link_li' ><a title='Instagram' href='https://www.instagram.com/maimoun_ny/' target='_blank'><i class='fa fa-instagram' aria-hidden='true'></i></a></li><li class='tumblr_li link_li' ><a href='http://www.maimoun.tumblr.com' title='Tumblr' target='_blank'><i class='fa fa-tumblr' aria-hidden='true'></i></a><li class='snap_li link_li'><a href='https://www.pinterest.com/maimounstore/' title='Pinterest' class='snap' target='_blank'><span class='icon icon-pinterest' aria-hidden='true'></span></a></li><li class='sound_li link_li' ><a href='https://soundcloud.com/user-276348909' title='Soundcloud' target='_blank'><i class='fa fa-soundcloud' aria-hidden='true'></i></a></li></ul>").insertAfter($(this));

  //     }
  //   });


  $(".site-footer__linklist li").each(function(){
    var txt = $(this).find("a").text();
    if( txt.indexOf("About") > -1)
    { 
      $("<ul class='footer_sub _hide'><li class='fb_li link_li' ><a title='Facebook' href='https://www.facebook.com/maimoun_ny/' target='_blank'><i class='fa fa-facebook' aria-hidden='true'></i></a></li><li class='insta_li link_li' ><a title='Instagram' href='https://www.instagram.com/maimoun_store/' target='_blank'><i class='fa fa-instagram' aria-hidden='true'></i></a></li><li class='tumblr_li link_li' ><a href='http://www.maimoun.tumblr.com' title='Tumblr' target='_blank'><i class='fa fa-tumblr' aria-hidden='true'></i></a><li class='snap_li link_li'><a href='https://www.pinterest.com/maimounstore/' title='Pinterest' class='snap' target='_blank'><span class='icon icon-pinterest' aria-hidden='true'></span></a></li></ul>").insertAfter($(this));

    }
  });

  $(".site-footer__linklist li").each(function(){
    var txt = $(this).find("a").text();
    if( txt.indexOf("FOLLOW") > -1)
    {   $(this).removeAttr('href');
     $(this).on("click", function(e){
       e.preventDefault();
       $(this).next(".footer_sub").toggleClass("_hide");
     });
    }
  });

  //   $("#AccessibleNav li").each(function(){

  //   		var col = $(this).find("a").text();

  //         if(col.indexOf("Collections") > -1)
  //         {
  //            console.log(">>");
  //         	$(this).find("a").css("font-style", "italic");
  //         }
  //   })

  //   trigger variant select

  $(document).on("click",'.size_list li', function(){
    $(".notify-me-wrapper").hide();
    $('.err_msg, .errors.qty-error').hide();
    //     $(this).parents('.product-single__form').children('.yess').hide();
    var slct_opt = $(this).text();
    var src_id  = $(this).attr('varid');
    $(this).siblings('.product-single__add-to-cart').hide();
    $(this).closest('.product-single__form').find('#'+src_id).show().siblings('.product-single__add-to-cart').hide();

    //     console.log(slct_opt);
    $(this).addClass("selected").siblings().removeClass("selected");


    $(this).closest("#AddToCartForm").find(".quick_varient_select").find("option").each(function(){
      var match_str = $(this).text();
      if(slct_opt == match_str)
      {
        $(this).prop("selected", true).siblings().removeAttr("selected");
        $(this).parent(".quick_varient_select").trigger("change");
      }
    });
  });
  //   end trigger variant select

  $(window).on("resize", function(){
    if (Modernizr.touch){
      $(".quick-view-items").css("display", "none");
    }

    jQuery(".grid-product-information").height(jQuery(".grid-product__image-wrapper").height() + 10);  


  });

  jQuery(".grid-product-information").height(jQuery(".grid-product__image-wrapper").height() + 10);  


  //   jQuery(".grid-product").on('mouseover', function() {
  //     if($(window).width() > 900)
  //     {      
  //       jQuery(this).find(".grid-product-information").fadeIn();
  //     }
  //   });
  //   jQuery(".grid-product").on('mouseout', function() {
  // 	jQuery(this).find(".grid-product-information").fadeOut();
  //   });

  //   Desktop 

  jQuery(document).on('click', '.template-collection .grid-product-information, .template-collection .grid-product__image-wrapper, .template-search .grid-product-information, .template-search .grid-product__image-wrapper', function(e) {

    $(".notify-me-wrapper").hide();
    $(".errorMsg.latesth3").hide();

    $(".is-sold-out").trigger('mouseover');

    if($(window).width() > 900)
    {
      if (Modernizr.touch){ } 
      //else { e.preventDefault(); }
    }

    if(parseInt($(this).prev(".grid-product__image-wrapper").css("right")) <= 0)
    { 
      
      jQuery(this).closest(".grid__item.grid-product").find('.see-more a').trigger('click');
      top.window.location.href = jQuery(this).prev().find('.grid-product__image-link').attr('href');
      $(this).parent(".grid-product__wrapper").find(".grid-product__image-wrapper").animate({'right':0},0);
      $('.grid__item.data-item').removeClass('active-item');
      if(jQuery(this).hasClass('right')) {
        jQuery(this).parents(".grid__item").prev().animate({'right':0},0);
      }

      return false;
    }


    counterF = 0;
    var checkLiLength = $(this).closest('.grid-product__wrapper').find('ul.size_list li').length;
    if(checkLiLength > 0) {
      $(this).closest('.grid-product__wrapper').find(".size_list li").each(function(){
        $(this).closest('.grid-product__wrapper').find(".size_list li.order-now").eq(0).trigger('click').addClass('preselected').removeClass('selected');
      });
    }
    else {
      $(this).closest('.grid-product__wrapper').find('.size_list').next('.product-single__add-to-cart').show();
    }
    $(".single-option-radio input[type='radio']:checked+label").css("border","none");
    $(".grid__item,.grid-product__image-wrapper").animate({'right':0},0);
    $('.grid-product__image-wrapper').closest('.grid.grid-collage').find(".grid__item").siblings().find('.grid-product__image-wrapper').animate({'right':'0'}, 0);    

    if(jQuery(this).hasClass('right')) {
      var previous_elem = jQuery(this).parents(".grid__item").prev();
      var current_elem = jQuery(this);
      jQuery(current_elem).parents(".grid-product").find(".grid-product__image-wrapper").animate({'right':'0px'}, 0);
      jQuery(current_elem).parent().find(".grid-product__image-wrapper").animate({'right':'0px'}, 0);
      jQuery(previous_elem).animate({'right':'0px'}, 0);
      $(this).closest('.grid__item.data-item').addClass('active-item').siblings().removeClass('active-item');


    }
    else if(jQuery(this).hasClass('left')){    
      var current_elem = jQuery(this);
      jQuery(current_elem).parents(".grid-product").find(".grid-product__image-wrapper").animate({'right':'0px'}, 0);
      jQuery(current_elem).parent().find(".grid-product__image-wrapper").animate({'right':'0px'}, 0, function(){
      });
      $(this).closest('.grid__item.data-item').addClass('active-item').siblings().removeClass('active-item');

    }
    else {
      var current_elem = jQuery(this);
      jQuery(current_elem).parents(".grid-product").find(".grid-product__image-wrapper").animate({'right':'0px'}, 0);
      jQuery(current_elem).parent().find(".grid-product__image-wrapper").animate({'right':'0px'}, 0);
      $(this).closest('.grid__item.data-item').addClass('active-item').siblings().removeClass('active-item');      
    } 

    $(".is-sold-out").each(function(e){

      if($(this).parent().parent().parent().parent().hasClass('active-item')){
        $(this).find(".sold-out-text").hide();

      }
      else{
        // $(this).find(".sold-out-text").show();
      }
    });

    return true;

  });

  jQuery(document).on('click', '.template-collection .grid-product__image-link' , function(e) { 
    var thisBlockId = '#' + $(this).closest('.grid-product').attr('id'); 
    setCookie('$_prdid', thisBlockId);
    e.stopPropagation();
  });



  $(document).on('click', function(e) { // Hides the div by clicking any where in the screen     



    if ( $(e.targetd).closest('.grid-product-information, .quick-view-items').length ) {
      $('.grid-product__image-wrapper').closest('.grid.grid-collage').find(".grid__item").siblings().find('.grid-product__image-wrapper').animate({'right':'0'}, 0);
      $(".grid-product__image-wrapper").animate({'right':'250'}, 0);
      //            $(".grid-product__image2").toggleClass("_hide");
      //       $(".grid-product__image").toggleClass("_hide");

    }else if ( ! $(e.target).closest('.grid-product-information, .quick-view-items').length ) {
      $('.grid__item.data-item').removeClass('active-item');

      $(".grid-product__image-wrapper").animate({'right':'0'}, 0);
      $(".grid__item.data-item").animate({'right':'0'}, 0);
      $(".grid__item.data-item").closest(".grid-collage").find(".grid-product-information").animate({'right':'0'}, 0, function(){
        //$(".quick-view-items #AddToCart").css({opacity: 0}); 
      });

    }


    $(".is-sold-out").each(function(e){

      if($(this).parent().parent().parent().parent().hasClass('active-item')){

        $(this).find(".sold-out-text").hide();
      }
      else{
        // $(this).find(".sold-out-text").show();
      }
    });



  });

});


$(document).ready(function(){
  var form = ''; // contact form
  var parent = "";
  jQuery(document).on("click",".notify_me", function(){ 

    $(".thankyoumsg").hide();
    form = jQuery(this).closest('.product-single__form');
    //       console.log($(form));
    jQuery(this).closest('.product-single__form').siblings('.contact-form').find('.notify-me-wrapper').show();

    // $(this).next(".errorMsg").toggleClass("errormsgNew");		


    form.on('submit', function(e) {
      e.preventDefault(); // prevent default form submit
      $.ajax({
        url: '/contact#contact_form', // form action url
        type: 'POST', // form submit method get/post
        dataType: 'html', // request type html/json/xml
        data: form.serialize(), // serialize form data                         
        success: function(data) {
          jQuery(this).parent().parent().find('.notify-me-wrapper').fadeOut();
          jQuery(this).parent().parent().find('.notify_me').text("Thanks! We will notify you when this product becomes available!");
        },
        error: function(e) {
          console.log(e)
        }
      });
    });
    return false;

  });



  jQuery(document).on('click','.notify_submit',function(){
    //     console.log(form.serialize());
    $.ajax({
      url: '/contact#contact_form', // form action url
      type: 'POST', // form submit method get/post
      dataType: 'html', // request type html/json/xml
      data: form.serialize(), // serialize form data                         
      success: function(data) {
        //             console.log(data);
        jQuery(form).find('.notify-me-wrapper').fadeOut();
        jQuery(form).find('.thankyoumsg').text("Thanks, you will be notified when this item returns.");
      },
      error: function(e) {
        //             console.log(e)
      }
    });
  });

  //var submit = $('#notify_submit');  // submit button
  setTimeout(function(){
    $('.collage-grid__row').each(function(){
      //     alert('ter');
      var getLnght = jQuery(this).find(".size_list li").length;
      if(getLnght > 0){
        $(this).find(".size_list li").eq(0).trigger('click').addClass('selected');
      }else{
        $(this).find('.size_list').next('.product-single__add-to-cart').show();
      }

    })
  },200)


});


/*Sahil code*/
// $(window).on("unload", function() {
//  // delete your cookie here
//   $.removeCookie('play_pause');

// });

var play_pause = jQuery.cookie("play_pause");
if(play_pause == null || play_pause == undefined){
  jQuery.cookie('play_pause', 0, { expires: null, path: '/' });  	
}
// var play_pause = 0;
var is_frame_loaded = 0;

$(document).ready(function(){
  //   console.log("running");
  if(play_pause == 1){
    var img_src = jQuery('#play_pause').find('img').attr("src").replace("stop","pause");
    jQuery('#play_pause').find('img').attr("src",img_src);
  }
  else
  {
    //        var img_src = jQuery('#play_pause').find('img').attr("src").replace("pause","stop");
    jQuery('#play_pause').find('img').attr("src",img_src);
  }
});


jQuery(window).on("load", function(){
  if(play_pause == 1){
    var img_src = jQuery('#play_pause').find('img').attr("src").replace("stop","pause");
    jQuery('#play_pause').find('img').attr("src",img_src);
  }
  else
  {
    //        var img_src = jQuery('#play_pause').find('img').attr("src").replace("pause","stop");
    jQuery('#play_pause').find('img').attr("src",img_src);
  }

  var iframe = $('#scmframe').contents();
  var iframe2 = iframe.find('#content').contents();

  play_pause = 0;



  jQuery(document).on('click','#play_pause',function(e){
    console.log(play_pause);
    //alert(play_pause);
    if(play_pause == 1){

      //       	var img_src = jQuery(this).find('img').attr("src").replace("pause","stop");
      jQuery(this).attr("title","Play");
      //         jQuery(this).text("Play");
      //         jQuery(this).css("left",-3);
      //alert($(".site-footer.small--text-center").css("height"));
      if($(".site-footer.small--text-center").css("height") == "500px"){
        $(".site-footer").css({background: 'transparent', opacity: 1});
        $("#_list_toggle").trigger("click");
      }
      //AnimateRotateR(0);
      //

      //
      //$("._popup_list").removeClass("asdf");


      //       	console.log($(parent.document).find('#pause'));
      $(parent.document).find("#pause").trigger('click');
      jQuery(this).find('img').attr("src",img_src);
      jQuery.cookie('play_pause', 0, { expires: null, path: '/' });
      play_pause = jQuery.cookie("play_pause");
    }
    else{

      var img_src = jQuery(this).find('img').attr("src").replace("stop","pause");
      jQuery(this).attr("title","Pause");
      //         jQuery(this).text("Pause");
      //         jQuery(this).css("left",-7);
      $(parent.document).find("#play").trigger('click');
      jQuery(this).find('img').attr("src",img_src);
      jQuery.cookie('play_pause', 1, { expires: null, path: '/' });
      play_pause = jQuery.cookie("play_pause");
    }

  });

  jQuery('#scm_llayback_list').append('<div class="_popup_list"></div>');
  //alert("IN@@@@@@@@@@@@@@@@@@@@@@@@@@@");
  //alert($(parent.document).find('#playlistContainer').html());
  setTimeout(function(){
    if(iframe.find('#playlistContainer').html() != undefined){

      iframe2.find('._popup_list').html(iframe.find('#playlistContainer').html());
    }
    else if($(parent.document).find('#playlistContainer').html() != undefined){
      console.log("else");
      console.log($(parent.document).contents().find('#contentW').find("#content").contents().find("._popup_list"));
      $(parent.document).contents().find('#contentW').find("#content").contents().find("._popup_list").html($(parent.document).find('#playlistContainer').html());
    } 
  },1200);


  jQuery('.rightLinks').show(); 

  jQuery(document).on('click','._popup_list ol li',function(){
    $('._popup_list ol li').removeClass("focus");
    $(this).addClass('focus');
    //     console.log($(this).index());
    $(parent.document).find("#playlistContainer ol li:eq("+$(this).index()+")").trigger('click');
    jQuery.cookie('playback_index', $(this).index(), { expires: null, path: '/' });
    jQuery.cookie('play_pause', 0, { expires: null, path: '/' });
    play_pause = jQuery.cookie("play_pause");
    jQuery('#play_pause').trigger('click');
  });

  var click_list = 0;
  jQuery('#_list_toggle').on('click',function(){
    //      $("ol.items li:first").trigger("click");
    if(click_list  == 0) {
      $('._popup_list').fadeIn("fast", function() {
        // Animation complete
      });
      click_list = 1;
    }
    else{
      $('._popup_list').fadeOut("fast", function() {
        // Animation complete
      });
      click_list = 0;
    }
    $(this).find('img').toggleClass("active");

  });


  var current_song = jQuery.cookie("playback_index");
  
  if(current_song == null || current_song == undefined){
    jQuery.cookie('playback_index', 0, { expires: null, path: '/' });  	
  }
  //jQuery(parent.document).find("#playlistContainer ol li").removeClass('focus');
  //jQuery(parent.document).find("#playlistContainer ol li:eq("+current_song+")").addClass('focus');
  jQuery("._popup_list ol li").removeClass('focus');
  jQuery("._popup_list ol li:eq("+current_song+")").addClass('focus');


  var current_index = 0;
  setInterval(function(){
    var current_title = jQuery(parent.document).find('#title').html();
    var current_active_ele = jQuery("._popup_list ol li.focus span.title").html();

    $('._popup_list ol li').each(function(index,key){
      if($(key).find('span').html() == current_title){
        current_index = index;
      }
    });
    if(current_title != undefined ){
      // console.log(current_title+" "+current_active_ele+" "+current_index);
      if(current_title !=  current_active_ele){
        var new_index = parseInt(current_index);
        if(new_index < 0){
          new_index = 0;
        }
        var cookie_index = parseInt(current_index);
        if(cookie_index < 0){
          cookie_index = 0;
        }
        console.log(new_index+" "+cookie_index);
         jQuery.cookie('playback_index', current_index, { expires: null, path: '/' });  	
        jQuery("._popup_list ol li").removeClass('focus');
        jQuery("._popup_list ol li:eq("+new_index+")").addClass('focus');
      }
    }

  },1000);

  $('#Hero video').each(function () {
    this.play();
  });
});

// iframe2.load(function(){
// 	setTimeout(function(){
//     if(iframe.find('#playlistContainer').html() != undefined){
//     	iframe2.find('._popup_list').html(iframe.find('#playlistContainer').html());
//     }
//   		},500);
// });




// $('#scmframe').contents().find("#content").load(function(){
//     console.log('load the iframe')
//     //the console won't show anything even if the iframe is loaded.
// })

$(".overlay-div").click(function(){
  $(this).hide();
  $("#_list_toggle").trigger("click");
});

$("#_list_toggle").on("click", function(){


  $("._popup_list").addClass("asdf");

  //   $("#_list_toggle img.active").animate({'transform':'roate(90deg)'}, 1000);
  if($("._popup_list").is(":visible"))
  {
    AnimateRotateR(0);
    $(".site-footer").css({background: 'transparent', opacity: 1});
    $(".player-title-text").fadeOut(100);
    $(".site-footer").animate({'height':'auto'}, 1000);    
    $(".overlay-div").hide();

  }
  else
  {
    AnimateRotate(90);
    $(".site-footer").css({background: '#fff', opacity: .8, 'z-index': '9999999999'});
    $(".site-footer").animate({'max-height':'500px', 'height':'500px'}, 800);  
    $(".overlay-div").show();
    $(".player-title-text").fadeIn(1000);
    //     $(".site-footer").animate({'height':'100%'}, 1000); 
  }
  if($(window).width() > 768){
    $("#scm_llayback_list").niceScroll({cursorcolor:"#000"}).resize();  
  } else{
    //      $('html, body').animate({ scrollTop: $(".site-footer").offset().top }, 1000);
    $("#scm_llayback_list").niceScroll({cursorcolor:"#000"}).remove();  
  }
});

if($(window).width() > 768){
  $(window).on("scroll", function(e){
    if($("._popup_list").is(":visible") && $("._popup_list").hasClass("asdf"))
    {
      AnimateRotateR(0);
      $(".site-footer").css({background: 'transparent', opacity: 1, 'z-index': '999'});
      //   $(".site-footer").animate({'height':'100%'}, 1000);
      $("#_list_toggle").trigger("click");
      $("._popup_list").removeClass("asdf");
      $(".overlay-div").hide();
      return false;
    }
  });
}

function AnimateRotate(angle) {
  // caching the object for performance reasons
  var $elem = $('#_list_toggle img');
  $(".site-footer").animate({'max-height':'500px', 'height':'500px'}, 650); 
  // we use a pseudo object for the animation
  // (starts from `0` to `angle`), you can name it as you want
  $({deg: 0}).animate({deg: angle}, {
    duration: 825,
    step: function(now) {
      // in the step-callback (that is fired each step of the animation),
      // you can use the `now` paramter which contains the current
      // animation-position (`0` up to `angle`)
      $elem.css({
        transform: 'rotate(' + now + 'deg)'
      });
    }
  });
}

function AnimateRotateR(angle) {
  // caching the object for performance reasons
  var $elem = $('#_list_toggle img');
  $(".site-footer").animate({'max-height':'500px', 'height':jQuery("footer .footer_links").height()}, 650); 
  //$(".site-footer").animate({'max-height':'500px', 'height': "500px"}, 650); 
  // we use a pseudo object for the animation
  // (starts from `0` to `angle`), you can name it as you want
  $({deg: 90}).animate({deg: angle}, {
    duration: 825,
    step: function(now) {
      // in the step-callback (that is fired each step of the animation),
      // you can use the `now` paramter which contains the current
      // animation-position (`0` up to `angle`)
      $elem.css({
        transform: 'rotate(' + now + 'deg)'
      });
    }
  });
}


function check_if_mobile() {
  var isMobile = navigator.userAgent.match(/iPad|iPhone|Android|Blackberry/i);

  if(isMobile) {
    //     console.log("Viewing on Mobile device");
    jQuery("footer .rightLinks").addClass("mobile_footer");
  }
  else {
    //   	console.log("Viewing on Desktop");
  }
}





//Load More Funcitonality

$(document).ready(function(){
  function blinker() {
    $('.loading').fadeOut(800).fadeIn(800);
    $('.template-collection .grid-product-information').removeClass('left, right');
    $('.template-collection .box_half_width:nth-child(odd)').find('.grid-product-information').addClass('left').removeClass('right');
    $('.template-collection .box_half_width:nth-child(2n)').find('.grid-product-information').addClass('right').removeClass('left');
    $('.template-collection .box_half_width:nth-child(odd)').addClass('left-item');
    $('.template-collection .box_half_width:nth-child(2n)').addClass('right-item');
    jQuery(".grid-product-information").height(jQuery(".grid-product__image-wrapper").height() + 5); 

  }

  setInterval(blinker, 1000);


  //   $('.pagination').css('opacity','0');
  var taskFired = true;//flag
  var pageNumber = 1;
  var paginationLength = $('.pagination span.page').length - 1;




  


  //   var myDiv = $('.article-content');
  // myDiv.text(myDiv.text().substring(0,180))
})

// $(function(){
//   $(".article-content").children().each(function(i){
//     len=$(this).text().length;
//     if(len>80)
//     {
//       console.log($(this).text($(this).text().substr(0,80)));
//     }
//   });
// });


// $(window).on('load', function(){
//   $('.collage-grid__row.box_half_width').each(function(){
//   	var getULLenght = $(this).find('form.product-single__form').find('ul.size_list').length;
//     if( getULLenght > 0){
//       $(this).find('form.product-single__form').find('ul.size_list li:first').trigger('click');
//     }else{
//       $(this).find('form.product-single__form').find('ul.size_list').next('.product-single__add-to-cart').css('display','block');
//     }
//   });
// })
